import { BackAppBar, GalleryImage } from "@/components/ui";
import { cn } from "@/libraries/cn";
import type { GalleriesCheckSchema } from "@/schemas";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import { Link } from "@tanstack/react-router";
import type React from "react";
import { useMemo, useState } from "react";

interface DrawerViewSelectProps extends React.ComponentPropsWithoutRef<"div"> {
	files: GalleriesCheckSchema["ids"];
	onClose: () => void;
}

const DrawerViewSelect: React.FC<DrawerViewSelectProps> = ({
	files,
	onClose,
	className,
	...props
}) => {
	const [selectedIdx] = useState<number>(0);
	const currFile = useMemo(() => files[selectedIdx], [files, selectedIdx]);

	return (
		<div className={cn("relative h-dvh w-screen", className)} {...props}>
			<div className="wrapper">
				<div className="flex flex-col gap-4">
					<BackAppBar onBack={onClose} title="View Files" />
					<div className="container">
						<div className="relative aspect-[3/2] bg-dark">
							{currFile ? (
								<>
									<img
										src={currFile.file_id}
										alt={currFile.file_id}
										className="w-full h-full object-contain object-center"
									/>
									{/* <Link
										to="/dashboard/gallery/view/$id"
										params={{ id: currentImage }}
										preload={false}
									> */}
									<IconButton
										type="button"
										color="primary"
										size="large"
										className="!absolute top-2 right-2 z-10 !bg-white"
									>
										<EditIcon fontSize="medium" />
									</IconButton>
									{/* </Link> */}
								</>
							) : null}
						</div>
					</div>
					<div className="container overflow-x-auto py-4">
						<div className="flex flex-row gap-4 [&_div]:w-40 [&_div]:flex-shrink-0 [&_a]:w-40 [&_a]:flex-shrink-0">
							{files.map((file, imageIdx) => (
								<GalleryImage
									key={file.id}
									imgSrc={file.file_id}
									imgAlt={file.file_id}
									isActive={imageIdx === selectedIdx}
									onClickRemove={(e) => null}
									onViewImage={() => null}
								/>
							))}
							{/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
							{/* biome-ignore lint/a11y/useFocusableInteractive: <explanation> */}
							<div
								// biome-ignore lint/a11y/useSemanticElements: <explanation>
								role="button"
								title="close"
								className="relative aspect-[3/2] overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 ease-in-out border-2 border-dashed border-secondary flex justify-center items-center"
								onClick={() => onClose()}
							>
								<IconButton
									size="large"
									color="primary"
									className="!bg-secondary"
									onClick={() => onClose()}
								>
									<AddIcon className="text-blue-950" />
								</IconButton>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default DrawerViewSelect;
